/**
 * Mã màn hình
 */
export default {
  Login: 'login',
  RoleManagement: 'RoleManagement',

  //#region Tổng quan
  Dashboard: 'Dashboard',
  //#endregion

  //#region Tiền mặt tại quỹ
  CashProcess: 'CashProcess',
  CashReceipt: 'CashReceipt',
  CashPayment: 'CashPayment',
  //#endregion

  //#region Biên lai
  TicketProcess: 'TicketProcess',
  Ticket: 'Ticket',
  TicketList: 'TicketList',
  //#endregion

  //#region Tiền gửi ngân hàng
  DepositProcess: 'DepositProcess',
  Cheque: 'Cheque',
  Deposit: 'Deposit',
  //#endregion

  //#region Tài sản - tang vật
  AssetProcess: 'AssetProcess',
  AssetTransfer: 'AssetTransfer',
  Inventory: 'Inventory',
  InwardStock: 'InwardStock',
  OutwardStock: 'OutwardStock',
  //#endregion

  //#region Phân phối
  DistributionProcess: 'DistributionProcess',
  AccountTransferSlipVoucher: 'AccountTransferSlipVoucher',
  AccountTransferSlipVoucherDetail: 'AccountTransferSlipVoucherDetail',
  JusticeReceipt: 'JusticeReceipt',
  JusticeSelling: 'JusticeSelling',
  VoucherList: 'VoucherList',
  //#endregion

  //#region Phân hệ tổng hợp toàn ngành
  ReceiveSubOrgReport: 'ReceiveSubOrgReport',
  //#endregion
  //#region Sổ cái
  LedgerProcess: 'LedgerProcess',
  SubmitReport: 'SubmitReport',
  AssetEvaluation: 'AssetEvaluation',
  GeneralJournalEntry: 'GeneralJournalEntry',
  //#endregion

  //#region Báo cáo
  Report: 'Report',
  //#endregion

  //#region Ký số
  DigitalSign: 'DigitalSign',
  //#endregion

  //#region Kết nối nền tảng số
  FptConnect: 'FptConnect',
  //#endregion

  //#region Kho bạc điện tử
  Etreasury: 'Etreasury',
  ConnectDVCMultiBudgetCode: 'ConnectDVCMultiBudgetCode',
  //#endregion

  //#region Thiết lập chữ ký số
  SigningSetting: 'SigningSetting',
  //#endregion

  //#region Chuyển tài khoản hạch toán
  DIAccount: 'DIAccount',
  //#endregion

  //#region Số dư ban đầu
  AccountBalanceTab : 'AccountBalanceTab',
  AssetAccountBalanceTab : 'AssetAccountBalanceTab',
  ObjectAccountBalanceTab : 'ObjectAccountBalanceTab',
  BankAccountBalanceTab : 'BankAccountBalanceTab',
  ObjectAndDecisionAccountBalanceTab : 'ObjectAndDecisionAccountBalanceTab',
  OtherAccountBalanceTab : 'OtherAccountBalanceTab',
  //#endregion

  //#region Danh mục
  Dictionary: 'Dictionary',
  DiAsset: 'DiAsset',
  DiAssetCategory: 'DiAssetCategory',
  DiReceipt: 'DiReceipt',
  DiAccountCategory: 'DiAccountCategory',
  DiStock: 'DiStock',
  DiCurrency: 'DiCurrency',
  DiBankInfo: 'DiBankInfo',
  DiBankStandard: 'DiBankStandard',
  DiAccount: 'DiAccount',
  DIAccountTransfer: 'DIAccountTransfer',
  DIDefaultAccount: 'DIDefaultAccount',
  DIListCode: 'DIListCode',
  DIBranch: 'DIBranch',
  DIArea: 'DIArea',
  DIAccountingObject: 'DIAccountingObject',
  DIJusticeCase: 'DIJusticeCase',
  DIJusticeCaseType: 'DIJusticeCaseType',
  DIJusticeDecesion: 'DIJusticeDecesion',
  DIJusticeDecesionGroup: 'DIJusticeDecesionGroup',
  //#endregion

  //#region Hệ thống
  InfoData: 'InfoData',
  ChangeObject: 'ChangeObject',
  TransferExecutor: 'TransferExecutor',
  CheckValidAmount: 'CheckValidAmount',
  CheckValidVoucher: 'CheckValidVoucher',
  CompanyInfo: 'CompanyInfo',
  AccessHistory: 'AccessHistory',
  UserManagement: 'UserManagement',
  DataManagement: 'DataManagement',
  //#endregion
};
